import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setDialogVisible } from "../../actions/session";
import ProgressBar from "../../controls/ProgressBar";
import Spinner from "../../controls/Spinner";
import { nextProfileId as nextProfileIdSelector, profileById as profileByIdSelector, } from "../../util/selectors";
import { Dialog } from "../Dialog";
import { DialogContainer } from "../DialogContainer";
/**
 * Provides a profile switcher component.
 * For both layouts.
 */
export const ProfileSwitcher = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const nextProfileId = useSelector(nextProfileIdSelector);
    const progressProfile = useSelector((state) => state.session.base.progress?.profile);
    const visibleDialog = useSelector((state) => state.session.base.visibleDialog || undefined);
    const onHideDialog = useCallback(() => {
        dispatch(setDialogVisible(undefined));
    }, [dispatch]);
    const deploying = progressProfile?.deploying;
    const profile = useSelector((state) => nextProfileId !== undefined
        ? profileByIdSelector(state, nextProfileId)
        : undefined);
    const control = deploying ? (React.createElement(ProgressBar, { labelLeft: deploying.text, now: deploying.percent, style: { width: "50%" } })) : (React.createElement(Spinner, { style: { width: 64, height: 64 } }));
    return (React.createElement("div", { key: "wait" },
        React.createElement("div", { className: "center-content", style: { flexDirection: "column" } },
            React.createElement("h4", null, t("Switching to Profile: {{name}}", {
                replace: { name: profile?.name ?? t("None") },
            })),
            control),
        React.createElement(Dialog, null),
        React.createElement(DialogContainer, { visibleDialog: visibleDialog, onHideDialog: onHideDialog })));
};
